import ValueInterface, { SerializedValueType } from "./ValueInterface"

export default class FactorialValue implements ValueInterface {
  constructor(private readonly base: ValueInterface) {}

  public toString(): string {
    return `${this.base}!`
  }

  public normalize(): number {
    let result: number = 1
    for (let i: number = 1, l = this.base.normalize(); i <= l; i++) {
      result *= i
    }

    return result
  }

  public clone(): ValueInterface {
    return new FactorialValue(this.base)
  }

  public toJSON(): SerializedValueType {
    return {
      type: "factorial",
      payload: { base: this.base },
    }
  }
}
